import axios from "axios";
//import FormData from "form-data";
import {AdminBaseUserListEndPoint, AdminAddBaseUserEndPoint, AdminEditBaseUserEndPoint, AdminDeleteBaseUserEndPoint} from "../../../config/AppServerConfig";
import {GlobalConfig} from "./../../../Services/Helper/GlobalConfig";

// axios.interceptors.response.use((response) => {
//   return response;
// }, function (error) {
//   return Promise.reject(error.response);
// });

class AdminBaseUserListServices {
    static getAdminBaseUserList(pageNum) {
        if (!pageNum) {
            pageNum = 1;
        }
        const config = {
            headers: {"Authorization": GlobalConfig.Token}
        };
        return axios.get(AdminBaseUserListEndPoint + "?page=" + pageNum, config);
    }

}


class AdminAddBaseUserServices {
    static addAdminBaseUser(data) {
        const config = {
            headers: {"Authorization": GlobalConfig.Token}
        }
        return axios.post(AdminAddBaseUserEndPoint, data, config)
    }
}

class AdminEditBaseUserServices {
    static editAdminBaseUser(data) {
        const config = {
            headers: {"Authorization": GlobalConfig.Token}
        }
        let id = data.id;
        delete data.id;
        return axios.put(AdminEditBaseUserEndPoint+id, data, config)
    }
}

class AdminDeleteBaseUserServices {
    static deleteAdminBaseUser(id) {
        const config = {
            headers: {"Authorization": GlobalConfig.Token}
        }
        return axios.delete(AdminDeleteBaseUserEndPoint+"/"+id, config)
    }
}

export {AdminBaseUserListServices, AdminAddBaseUserServices, AdminEditBaseUserServices ,AdminDeleteBaseUserServices};
